import classNames from "classnames";
import PropTypes from "prop-types";
import React from "react";

function Card({ children, title, bg, className }) {
  return (
    <div
      className={classNames(
        `mobilityMutual__card mobilityMutual__card--${bg}`,
        className,
      )}
    >
      {title && <div className="mobilityMutual__card--title">{title}</div>}
      <div className="mobilityMutual__card--body">{children}</div>
    </div>
  );
}

Card.propTypes = {
  children: PropTypes.node.isRequired,
};

export default React.memo(Card);
